import { gql } from '__generated__'

export const GetLatestErrorDownload = gql(/* GraphQL */ `
    query GetLatestErrorDownload {
        latestErrorDownload {
            url
            updatedAt
        }
    }
`)
